import { getLocalizedUrl, prefixLocale } from 'helpers/url';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { AboutPageProps } from 'pages/about/[slug]';

export const SEOFaq = ({ data }: { data: AboutPageProps }) => {
  const router = useRouter();
  const url =
    'https://firi.com' +
    prefixLocale(router.locale, router.defaultLocale) +
    getLocalizedUrl(router.pathname, router.locale, router.query);

  const schemaOrgWebPage = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    url,
    mainEntity: data.content
      ?.filter((content) => content.faq)
      .map((content) => ({
        '@type': 'ItemList',
        name: content.title,
        numberOfItems: content.faqCollectionList[0]?.faqList?.length || 0,
        itemListElement: content.faqCollectionList[0]?.faqList?.map((faq) => ({
          '@type': 'Question',
          name: faq.title,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.body[0]?.children[0]?.text,
          },
        })),
      })),
  };

  return (
    <Head>
      <script
        key="structured-seo"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaOrgWebPage) }}
      />
    </Head>
  );
};
